/**
 * Utility functions for calculating chart domains with padding
 */

/**
 * Calculates domain min and max values with padding to prevent clipping
 * @param values - Array of numeric values to include in domain calculation
 * @param paddingPercent - Percentage of value range to add as padding (default: 0.25 = 25%)
 * @returns Object with domainMin and domainMax values
 */
export const calculateDomainWithPadding = (
  values: number[],
  paddingPercent: number = 0.25
): { domainMin: number; domainMax: number } => {
  if (!values || values.length === 0) {
    return { domainMin: 0, domainMax: 100 };
  }

  const maxValue = Math.max(...values);
  const minValue = Math.min(...values);
  const valueRange = maxValue - minValue;

  // Add generous padding to ensure NO clipping
  const absolutePadding =
    valueRange > 0
      ? valueRange * paddingPercent
      : Math.max(
          maxValue * paddingPercent,
          Math.abs(minValue) * paddingPercent || maxValue * paddingPercent || 1
        );

  // For minimum: always use at least 0, but subtract padding to ensure all low values are visible
  const min = Math.max(0, minValue - absolutePadding);
  // For maximum: always add padding above
  const max = maxValue + absolutePadding;

  return { domainMin: min, domainMax: max };
};

